export const words = [
    {
        word: 'ECOLE',
        clue: 'Apprentissage',
    },

    {
        word: 'PAPAYE',
        clue: 'Fruit exotique',
    },

    {
        word:'VOLDEMORT',
        clue: 'Personnage fictif',
    },

    {
        word: 'MEDECIN',
        clue: 'Métier',
    },
    
    {
        word: 'TEQUILA',
        clue: 'Boisson',
    },

    {
        word: 'ZOLA',
        clue: 'Ecrivain',
    },

    {
        word: 'CAPUCINE',
        clue: 'Fleur',
    },

    {
        word: 'AIGLE',
        clue: 'Rapace',
    },

    {
        word: 'TIRAMISU',
        clue: 'Dessert',
    },

    {
        word: 'ABIDJAN',
        clue: 'Capitale',
    },

    
    {
        word: 'RONGEUR',
        clue: 'Souris'
    },

    {
        word: 'CHAT',
        clue: 'Animal de compagnie'
    },

    {
        word: 'TITANIC',
        clue: 'Film culte'
    },

    {
        word: 'LINCOLN',
        clue: 'Ancien president'
    },

    {
        word: 'WASHINGTON',
        clue: 'Acteur'
    },

    {
        word: 'TAMBOUR',
        clue: 'Instrument de musique'
    },

    {
        word: 'BOIS',
        clue: 'Matière'
    },

    {
        word: 'VIETNAM',
        clue: 'Pays'
    },

    {
        word: 'HIROSHIMA',
        clue: 'Ville'
    },

    {
        word: 'MANIOC',
        clue: 'Tubercule'
    },

    {
        word: 'CAROTTE',
        clue: 'Légume'
    },

    {
        word: 'BATEAU',
        clue: 'Moyen de transport'
    },
];